// AUTO-GENERIERT von scripts/gen-emotes.mjs — nicht von Hand editieren.
// Quelle: public/illustrations/emoticons/hydra-*.png
export const EMOTE_NAMES: readonly string[] = [
  "100",
  "alien",
  "angel",
  "angry",
  "battery",
  "beaver",
  "bee",
  "blush",
  "books",
  "boom",
  "borg",
  "brain",
  "brainfull",
  "bug",
  "builder",
  "bulb",
  "calendar",
  "camera",
  "chart",
  "chart-up",
  "checkmark",
  "cheers",
  "chef",
  "clap",
  "clapper",
  "coffee",
  "confetti",
  "cool",
  "cowboy",
  "cross",
  "crossfingers",
  "cry",
  "crystal",
  "desktop",
  "detective",
  "devil",
  "dice",
  "dizzy",
  "dna",
  "doublefacepalm",
  "dragon",
  "drool",
  "drop",
  "explode",
  "eyeroll",
  "eyes",
  "facepalm",
  "fire",
  "fishing",
  "fist",
  "floppy",
  "gamepad",
  "gear",
  "gift",
  "globe",
  "gold",
  "graduation",
  "grimace",
  "grin",
  "hacker",
  "hammer",
  "handshake",
  "headphones",
  "hearts-face",
  "hmm",
  "hushed",
  "idea",
  "key",
  "king",
  "kiss",
  "lab",
  "laptop",
  "lightning",
  "link",
  "lobster",
  "lock",
  "lock-key",
  "lol",
  "love",
  "mic",
  "microphone",
  "microscope",
  "money",
  "moneybag",
  "monocle",
  "moon",
  "muscle",
  "music",
  "nerd",
  "neutral",
  "ninja",
  "no",
  "ok",
  "palette",
  "party",
  "pensive",
  "pirate",
  "plead",
  "plug",
  "popcorn",
  "pray",
  "question",
  "raised-eyebrow",
  "redheart",
  "refresh",
  "robot",
  "rocket",
  "rofl",
  "salad",
  "satellite",
  "scared",
  "scream",
  "search",
  "shield",
  "shrug",
  "shush",
  "sick",
  "siren",
  "skull",
  "sleepy",
  "smile",
  "smirk",
  "snail",
  "snake",
  "sparkle",
  "speaker",
  "speech",
  "spy",
  "star-glow",
  "starstruck",
  "stethoscope",
  "stop",
  "sun",
  "sunglasses",
  "sweat-smile",
  "tears",
  "theater",
  "thumbsdown",
  "thumbsup",
  "tophat",
  "tree",
  "trophy",
  "unamused",
  "upsidedown",
  "virus",
  "vulcan",
  "warning",
  "wave",
  "wink",
  "wizard",
  "woozy",
  "wow",
  "wrench",
  "zipper",
  "zzz"
]
